import React, { memo, useState } from "react";
import { handleGridTechname, renderDevInfo } from "../../GeneralScripts";
import { handleChildPotentialEmotion, showFormInModal } from "./ButtonFIeldFunctions";
import { Button, Message, Modal } from "../../../BP2Components";
import { handleChangedRelatedField } from "../../GeneralScripts";
import { Form } from "antd";
import { useFormContext } from "../../../../context/FormContext/FormContext";
import { useIntl } from "react-intl";
import "./ButtonField.less";

interface ButtonFieldProps {
   key: string;
   element: any;
   form: any;
   disabled: boolean;
   formId: any;
   isVisible: (element: any) => boolean;
}

const ButtonField: React.FC<ButtonFieldProps> = memo(
   ({ element, form, disabled, isVisible, formId }) => {
      const [modalData, setModalData] = useState({ openModal: false, dataForModal: {} });
      const { formData, changeFieldPendingStatus, setFieldsInfo, fieldEnumMap } = useFormContext();
      const intl = useIntl();

      const handleButtonClick = () => {
         // formAction = run form PUT
         if (element?.formAction === true) {
            handleChangedRelatedField(
               element,
               form,
               setFieldsInfo,
               [],
               formId,
               intl,
               formData._formKey,
               null,
               changeFieldPendingStatus,
               fieldEnumMap,
            );
         } else if (typeof element.txt1 === "string" && element.txt1 !== "") {
            const functionFromBackend = JSON.parse(element.txt1);
            // here we support specific functions, if there are too many of them and code becomes unreadable, create a global function returning the selected function
            if ("popup_article" in functionFromBackend) {
               // we just pass data to state, pass the state to "showFormInModal" function, and in the function we manage all the logic for showing the modal
               const recordIdTechname = functionFromBackend.popup_article.recordTechname;
               if (recordIdTechname && recordIdTechname.includes("{")) {
                  const techName = recordIdTechname.replaceAll("{", "").replaceAll("}", "");
                  functionFromBackend.popup_article.recordId = form.getFieldValue(techName);
               }
               setModalData({ openModal: true, dataForModal: functionFromBackend.popup_article });
            } else if ("popup_form" in functionFromBackend) {
               const recordIdTechname = functionFromBackend.popup_form.recordTechname;
               if (recordIdTechname && recordIdTechname.includes("{")) {
                  const techname = recordIdTechname.replaceAll("{", "").replaceAll("}", "");
                  functionFromBackend.popup_form.recordId = form.getFieldValue(techname);
               }
               setModalData({ openModal: true, dataForModal: functionFromBackend.popup_form });
            } else if ("ml_emotion" in functionFromBackend) {
               handleChildPotentialEmotion(form);
            }
         } else {
            Message.error(intl.formatMessage({ id: "wrong.function.expression" }));
         }
      };
      return (
         <>
            {/* here we are rendering the modal */}
            {modalData.openModal && showFormInModal(modalData, setModalData)}

            <Form.Item
               key={element.tech_name}
               className="button-field"
               style={{
                  display: isVisible(element) ? "" : "none",
                  gridArea: handleGridTechname(element.tech_name),
                  marginLeft: "0px",
               }}
            >
               <Button
                  buttonType="primary"
                  className={`button-field__btn field_${element.tech_name}`}
                  onClick={handleButtonClick}
                  disabled={disabled}
               >
                  {element?.label}
               </Button>
               {renderDevInfo(element)}
            </Form.Item>
         </>
      );
   },
);

export default ButtonField;
